/* eslint-disable class-methods-use-this */

import GtmEvent from 'Utils/GoogleTagManagerEvent';
import type { AnalyticsData, AnalyticsStrategy } from '../types';

export class GoogleAnalyticsProvider implements AnalyticsStrategy {
  sendEvent(eventName: string, data: AnalyticsData = {}) {
    GtmEvent({
      ...data,
      event: eventName,
    });
  }
}
